module.exports = __webpack_public_path__ + "3774cb49a0d0c538c5a87282e08bbc2a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pages/list-bg.gif
// module id = 558
// module chunks = 73